exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".strict-modal-padding {\n  padding: 40px 32px !important; }\n\n.success-get-plastic-modal__button {\n  top: 12px;\n  right: 12px;\n  position: absolute;\n  cursor: pointer;\n  width: 20px;\n  height: 20px; }\n", ""]);

// exports
